<div class="card" *ngIf="helpData.helpText">
  <div class="card-body">
    <iframe [style.height.px]="myInnerHeight" X-Frame-Options="*" (load)="isLoading=false" [class.d-none]="isLoading" [src]="iframeSRC"
      style="width: 100%;"></iframe>
  </div>
</div>
